import React from "react"
import { compare_list, display_list, display_list_r, display_list_p, 
            display_table2, compare_tables_new, display_balance, compare_balance } from './SnapUtils'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { ParentSnapshotCompare } from './ParentSnapshotCompare'
import { FamiliesEP } from '../../variables/Config'
import { snapshotOptions } from '../../variables/ComboValues'
import { family_program_info, family_housing, family_legal } from '../../variables/Required'
import { PImicroLegend } from './FamilyContact'
import { Housing_microLegend } from './FamilyHousing'
import { Legal_microLegend } from './FamilyLegal'
import { Income_microLegend } from './FamilyIncome'
import { Expenses_microLegend } from './FamilyExpenses'
import { Debts_microLegend } from './FamilyDebts'
import { Mortgage_microLegend } from './FamilyMortgage'
import { Savings_microLegend } from './FamilySavings'
//import { Balance_microLegend } from './FamilyBalance'
import { Rights_microLegend } from './FamilyRights'
import { RightsQ_microLegend } from './FamilyRightsQ'
import { ProductsServices_microLegend } from './FamilyProductsServices'
import YSpinner from  '../../elements/Spinner/Spinner'
import { countStotal } from './FamilySnapshot'

export class SnapshotCompare extends React.PureComponent{
    constructor(props){
        super(props)
        this._isMounted = false
        this.state = {
            //now: this.props.acf,
            isLoadingFrom: true,
            isLoadingTo: true,
            dfrom: {},
            dto: {}
        }

    }
          // fetch any snapshot (family or parent) by cpt id 
    fetchSnapshot(url, dir) {
            if (dir === 0) this.setState({isLoadingFrom: true}) 
            else this.setState({isLoadingTo: true}) 
    // http://yahav/wp-json/wp/v2/digma_families0/8676?fields=id,title,acf
            fetch(url)
            .then(response => {
                if (!this._isMounted) return null
                if (response.ok)
                    return response.json()
                throw new Error('fetchSnapshot: Something went wrong ...')
            })
            .then(cpt => {             
                if (!this._isMounted) 
                    return null
                if (dir === 0)
                    this.setState({dfrom:cpt, isLoadingFrom: false}) 
                else
                    this.setState({dto:cpt, isLoadingTo: false}) 
                return (cpt) // can be void - no one is looking...
            })/*.then( (cpt) => {
                console.log("fetch cpt",cpt)
                console.log("fetch dfrom",this.state.dfrom)
                console.log("fetch dto",this.state.dto)
                //console.log("FAMILYLOG",this.state.cpt['acf']['familylog_array'])
                //console.log("family_basic",this.state.cpt['acf']['family_basic'])
            })*/
            .catch(restError => {
                if (!this._isMounted) return null
                if (restError.name === 'AbortError') return; 
                this.setState({ restError: restError, isLoading: false })
            })
            return null
    }
    componentDidMount(){
        // is mounted
        this._isMounted = true
        const {snap, now} = this.props
        // which snapshot to bring countStotal
        //const sTotal = now['snapshots'] === undefined ? 0 : now['snapshots'].length
        const sTotal = countStotal(now['snapshots'])
        //console.log("compare did mount snap"+ snap + "  sTotal ="+sTotal)
        //console.log("compare did mount now", now['snapshots'])
        if (sTotal === 0){
            ////console.log("Scompare - did mount sTotal=0, snap=", snap)
            this.setState({isLoadingFrom: false, isLoadingTo: false})
            return null // nothing to load - Can show only now values...
        }
        if (sTotal === 1){
            // snap['from'] === snap['to'] === 'עכשיו'
            ////console.log("Scompare - did mount sTotal=1, snap=", snap)
            let fromIndex = snapshotOptions.indexOf(snap['from'])
            let link = now['snapshots'][fromIndex]['link']
            this.fetchSnapshot(FamiliesEP()+fromIndex+'/'+link+'?fields=id,title,acf', 0) // dir == 0 from
            if (snap['to'] === 'עכשיו'){
                let dto = Object.assign(this.props.cpt)
                this.setState({dto:dto, isLoadingTo: false})
            }
            // this.setState({isLoadingTo: false})
            return null // load ONLY from target -  now only...
        }
        //// console.log("Scompare - did mount sTotal="+sTotal+", snap=", snap)

        let fromIndex = snapshotOptions.indexOf(snap['from'])
        let toIndex = snapshotOptions.indexOf(snap['to'])
        //console.log("compare did mount from index="+fromIndex+"  to="+toIndex)
            // http://yahav/wp-json/wp/v2/digma_families0/8676?fields=id,title,acf
        // get family snapshots
        let link = now['snapshots'][fromIndex]['link']
        this.fetchSnapshot((FamiliesEP())+fromIndex+'/'+link+'?fields=id,title,acf', 0) // dir == 0 from
        if (snap['from'] === snap['to']){ // no need to bring 'to' - no compare!!!
            this.setState({/*dto:dto,*/ isLoadingTo: false})
            return null
        }
        if (snap['to'] === 'עכשיו'){
            let dto = Object.assign(this.props.cpt)
            this.setState({dto:dto, isLoadingTo: false})
        } else { // bring from serer
            link = now['snapshots'][toIndex]['link']
            this.fetchSnapshot(FamiliesEP()+toIndex+'/'+link+'?fields=id,title,acf', 1) // dir == 1 to
        }
       
    }
    componentWillUnmount() {
        this._isMounted = false
    }

    //this.getParentSnapshot(snap['fromId'],'mlink')
    // return cpt id
    getParentSnapshot(fromTo,gender){
        const {now} = this.props
        if (now === undefined) return -1 // internal error
        if (fromTo === "עכשיו"){
            let i = 0
            if (gender === 'mlink'){
                for (i = 0 ; i < now['family_members'].length; i++){
                    if (now['family_members'][i]['family_member_role'] === 'mother')
                        return now['family_members'][i]['family_member_cptid']
                }
                if (i >= now['family_members'].length)
                    return -1 // mother cpt id not found
            } 
            if (gender === 'plink'){
                for (i = 0 ; i < now['family_members'].length; i++){
                    if (now['family_members'][i]['family_member_role'] === 'father')
                        return now['family_members'][i]['family_member_cptid']
                }
                if (i >= now['family_members'].length)
                    return -1 // father cpt id not found
            }
            return -1 // internal error
        }
 
        let id = snapshotOptions.indexOf(fromTo) // snap['from']
        return now['snapshots'][id][gender]
    }

    DispPsnapshotCmp = (snap, link) => {
        return(
            <TabPanel>
                <ParentSnapshotCompare snaptype={'compare'} snap={snap}    
                        fromId={this.getParentSnapshot(snap['from'], link)} 
                        toId={this.getParentSnapshot(snap['to'], link)} />
            </TabPanel> 
        )
    }

    render(){
        const {snap, now} = this.props
        const {isLoadingTo, isLoadingFrom, dfrom, dto } = this.state
        //const sTotal = now['snapshots'] === undefined ? 0 : now['snapshots'].length
        const sTotal = countStotal(now['snapshots'])

        const manExists = now['program_info']['intake_family_man_name'].length
        const womanExists = now['program_info']['intake_family_woman_name'].length

        // let dFrom = this.props.now
        if (isLoadingTo || isLoadingFrom)
            return <YSpinner /> // <h2>טוען תמונות מצב...</h2>

        if (snap['from'] === "" && snap['to'] === "") return null
        
        let display = snap['from'] === snap['to'] ? 'snapshot' : "" // didmount loads data to snap['from']
                                                // WHY USE now ????
        let cTitle = display === 'snapshot'?  'הצגת נתוני ' + snap['from']
                     : 'השוואת נתונים בין ' + snap['from'] + ' ל-  ' + snap['to']
        
        let singleParent = womanExists && !manExists ? 3 : !womanExists && manExists ? 4 : 0 // 

        if (sTotal === 0 || snap['from'] === snap['to']){ // display snapshot no compare
            return (
                <div style={{clear:'both'}}>
                    <h3>{cTitle}</h3>
    
                    <Tabs>        
                        <TabList>
                            <Tab>נתוני המשפחה</Tab>
                            {!womanExists? "" : <Tab><span className="fname-female">נתוני האשה</span></Tab>}
                            {!manExists  ? "" : <Tab><span className="fname-male">נתוני הגבר</span></Tab>}
                        </TabList>
                        <TabPanel>
                            <div className="snap-display">
                                <div><br />
                                    <ul>
                                        <li>מידע חסר מוצג על רקע אפור.</li>
                                        <li>מידע קיים - תמיד יופיע. מידע חסר ולא הכרחי - לא יוצג. </li>
                                        <li>חד הוריות - לא יופיע הורה שני.</li>
                                        <li>יש "הקלות" עבור משפחות שאינן בתכנית.</li>
                                    </ul>
                                </div>
                                <h4>נתוני משפחה >> מידע כללי</h4>
                                {display_list_r(now['program_info'], PImicroLegend, family_program_info, singleParent)}
                                <h4>נתוני משפחה >> מגורים</h4>
                                {display_list_p(now['family_housing'], Housing_microLegend, family_housing)}
                                <h4>נתוני משפחה >> משפטי</h4>
                                {display_list_p(now['family_legal'], Legal_microLegend, family_legal)}
                                <h4>נתוני משפחה >> הכנסות</h4>
                                {display_table2(now['family_income'], Income_microLegend, 0, "income_sum")}
                                <h4>נתוני משפחה >> הוצאות</h4>
                                {display_table2(now['family_expenses'], Expenses_microLegend, 1, "expense_sum")}
                                <h4>נתוני משפחה >> התחייבויות</h4>
                                {display_table2(now['family_debts'], Debts_microLegend, 1, "family_debt_monthlyreturn")} 
                                <h4>נתוני משפחה >> משכנתאות</h4>
                                {display_table2(now['family_mortgage'], Mortgage_microLegend, 0, "mortgage_monthly")} 
                                <h4>נתוני משפחה >> חסכונות</h4>
                                {display_list(now['family_savings'], Savings_microLegend)}
                                <h4>נתוני משפחה >> מאזן</h4>
                                {display_balance(now)}
                                {/*display_list(now['family_balance'], Balance_microLegend)*/}
                                <h4>נתוני משפחה >> מוצרים ושירותים</h4>
                                {display_list(now['family_products_services'], ProductsServices_microLegend)}
                                <h4>נתוני משפחה >> זכויות</h4>
                                {display_table2(now['family_rights'], Rights_microLegend, 1, "rights_sum")}
                                
                                <h4>נתוני משפחה >> מיצו זכויות</h4>
                                {display_list(now['rights_q'], RightsQ_microLegend)}
                            </div>
                        </TabPanel>
                        {!womanExists ? "" : <TabPanel>
                                <ParentSnapshotCompare snaptype={'snapshot'} snap={snap} 
                                    fromId={this.getParentSnapshot(snap['from'],'mlink')} toId={null} />
                            </TabPanel>
                        }
                        {!manExists ? "" : <TabPanel>
                                <ParentSnapshotCompare snaptype={'snapshot'} snap={snap} 
                                    fromId={this.getParentSnapshot(snap['from'],'plink')} toId={null} />
                            </TabPanel>
                        }
                    </Tabs>
                </div>
                )
        }
                     
        return (
            <div style={{clear:'both'}}>
                <h3>{cTitle}</h3>

                <Tabs>        
                    <TabList>
                        <Tab>נתוני המשפחה</Tab>
                        {!womanExists? "" : <Tab><span className="fname-female">נתוני האשה</span></Tab>}
                        {!manExists  ? "" : <Tab><span className="fname-male">נתוני הגבר</span></Tab>}
                        {/*<Tab>מדדי שיפור</Tab>*/}
                    </TabList>
                    <TabPanel>
                        <h4>נתוני משפחה >> מידע כללי</h4>
                        {compare_list(dfrom['acf']['program_info'], dto['acf']['program_info'], PImicroLegend)}
                        <h4>נתוני משפחה >> מגורים</h4>
                        {compare_list(dfrom['acf']['family_housing'], dto['acf']['family_housing'], Housing_microLegend)}
                        <h4>נתוני משפחה >> משפטי</h4>
                        {compare_list(dfrom['acf']['family_legal'], dto['acf']['family_legal'], Legal_microLegend)}
                        <h4>נתוני משפחה >> הכנסות</h4>
                        {compare_tables_new(snap, dfrom, dto, 'family_income', Income_microLegend, 0, "income_sum")}
                        <h4>נתוני משפחה >> הוצאות</h4>
                        {/*compare_table(dfrom['acf']['family_expenses'], dto['acf']['family_expenses'], Expenses_microLegend)*/}
                        {compare_tables_new(snap, dfrom, dto, 'family_expenses', Expenses_microLegend, 1, "expense_sum")}
                        <h4>נתוני משפחה >> התחייבויות</h4>
                        {compare_tables_new(snap, dfrom, dto, 'family_debts', Debts_microLegend, 1, "family_debt_monthlyreturn")}

                        <h4>נתוני משפחה >> משכנתאות</h4>
                        {compare_tables_new(snap, dfrom, dto, 'family_mortgage', Mortgage_microLegend, 0, "mortgage_monthly")}

                        <h4>נתוני משפחה >> חסכונות</h4>
                        {compare_list(dfrom['acf']['family_savings'], dto['acf']['family_savings'], Savings_microLegend)}
                        <h4>נתוני משפחה >> מאזן</h4>
                        {/*compare_list(dfrom['acf']['family_balance'], dto['acf']['family_balance'], Balance_microLegend)*/}
                        {compare_balance(dfrom['acf'], dto['acf'], snap)}
                        <h4>נתוני משפחה >> מוצרים ושירותים</h4>
                        {compare_list(dfrom['acf']['family_products_services'], dto['acf']['family_products_services_end'], ProductsServices_microLegend)}
                        <h4>נתוני משפחה >> זכויות</h4>
                        {compare_tables_new(snap, dfrom, dto, 'family_rights', Rights_microLegend, 0, "rights_sum")}
                        <h4>נתוני משפחה >> מיצוי זכויות</h4>
                        {compare_list(dfrom['acf']['rights_q'], dto['acf']['rights_q'], RightsQ_microLegend)}
                    </TabPanel>
                    {!womanExists ? "" : this.DispPsnapshotCmp(snap, 'mlink')
                    /*<TabPanel>
                        <ParentSnapshotCompare snaptype={'compare'} snap={snap}    
                                    fromId={this.getParentSnapshot(snap['from'],'mlink')} 
                                    toId={this.getParentSnapshot(snap['to'],'mlink')} />
                        </TabPanel>*/
                    }
                    {!manExists ? "" : this.DispPsnapshotCmp(snap, 'plink')
                    /*<TabPanel>
                        <ParentSnapshotCompare snaptype={'compare'}  snap={snap}   
                                    fromId={this.getParentSnapshot(snap['from'],'plink')} 
                                    toId={this.getParentSnapshot(snap['to'],'plink')} />
                        </TabPanel>*/
                    }
                    {/*<TabPanel>
                    <h3>כאן יהיו מדדי שיפור</h3>
                    </TabPanel>*/}
                </Tabs>
            </div>
            )
        }
}

